import Skeleton from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const RoleDetails = ({ loading, role }) => {
	return (
		<div>
			<div className="bg-white rounded-8 p-20 mb-30">
				<div className="mb-20">
					<h2 className="text-xl text-medium-gotham mb-0">Role Information</h2>
				</div>
				<Row className="mb-50">
					<Col>
						<span className="info-label text-sm text-medium-gotham block">
							{loading ? (
								<Skeleton
									width={120}
									height={15}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								"Name"
							)}
						</span>
						<span className="info-val">
							{loading ? (
								<Skeleton
									width={"30%"}
									height={25}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								role?.name || "--"
							)}
						</span>
					</Col>
				</Row>
				<div className="mb-20">
					<h2 className="text-xl text-medium-gotham mb-0">Permissions</h2>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Logs</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.logs_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col />
						<Col />
						<Col />
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Announcements</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.announcements_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.announcements_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col />
						<Col />
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Students</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.students_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.students_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.students_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.students_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Personnel</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.personnel_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.personnel_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.personnel_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.personnel_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Devices</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.devices_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.devices_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.devices_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.devices_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Drivers</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.drivers_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.drivers_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.drivers_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.drivers_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Users</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.users_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.users_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.users_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.users_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="border rounded-8 p-20 mb-20">
					<div className="mb-20">
						<span className="text-medium-gotham">Roles</span>
					</div>
					<Row>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								View
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.roles_view ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Add
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.roles_write ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Edit
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.roles_edit ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								Delete
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"50%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : role?.roles_delete ? (
									"Yes"
								) : (
									"No"
								)}
							</span>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default RoleDetails;
